import { type Transition, type Variants } from 'framer-motion';

import { EASE_CUBIC } from '@pkg/components/Sections/Profile/StyledThemeProvider/themes/default';

const LAYOUT_Y_OFFSET = 32;

export enum LayoutVariant {
    Hidden = 'hidden',
    Show = 'show',
}

// TODO: There is a bug that disables the `backdrop-filter: blur()`
// over a overlaid element when a parent has an `opacity < 1`.
// That appears to happen in every browser except Safari.
export const layoutVariants: Variants = {
    [LayoutVariant.Hidden]: {
        opacity: 0,
        translateY: LAYOUT_Y_OFFSET,
    },
    [LayoutVariant.Show]: {
        opacity: 1,
        translateY: 0,
    },
};

export const layoutTransition: Transition = {
    ease: EASE_CUBIC,
    duration: 0.32,
};
